import { createStoreon } from 'storeon';

const ServiceRequestDealerFormStore = ( store ) => {
    store.on( '@init', () => ({
        groups: [
            {
                id: 0,
                disabled: false,
                fields: [
                    'location',
                    'dealer_account',
                    'dealer_first_name',
                    'dealer_email_address',
                    'dealer_phone',
                    'priority',
                    'service_type',
                ],
            },
            {
                id: 1,
                disabled: true,
                fields: [
                    'first_name',
                    'last_name',
                    'country',
                    'locality',
                    'administrative_area',
                    'postal_code',
                    'thoroughfare',
                    'premise',
                    'primary_phone',
                    'mobile_phone',
                    'email_address',
                    'customer_type',
                ],
            },
            {
                id: 2,
                disabled: true,
                fields: [
                    'contact_method',
                    'contact_subject'
                ],
            },
            {
                id: 3,
                disabled: true,
                fields: ['your_project'],
            },
            {
                id: 4,
                disabled: true,
                fields: ['additional_comments'],
            },
        ],
    }) );

    store.on( 'CHANGE_FIELDSET_STATE', ( { groups }, { id, disabled } ) => {
        const updatedGroups = groups.map( ( item ) => {
            if ( item.id === id ) {
                return { ...item, disabled };
            }
            return item;
        } );

        return {
            groups: updatedGroups,
        };
    } );
};


export default createStoreon( [ServiceRequestDealerFormStore] );
